"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitManualForm = void 0;
var submitManualForm = exports.submitManualForm = function submitManualForm(props) {
  var alphaPointUserID = props.alphaPointUserID,
    email = props.email,
    currentLevel = props.currentLevel,
    formValues = props.formValues,
    userName = props.userName,
    submitInfoManual = props.submitInfoManual,
    reset = props.reset,
    onSubmit = props.onSubmit;
  var underReviewLevel = (currentLevel + 1).toString();
  var Config = Object.keys(formValues || {}).map(function (key) {
    return {
      Key: key,
      Value: formValues[key]
    };
  });
  Config.push({
    Key: 'levelIncreaseStatus',
    Value: underReviewLevel
  }, {
    Key: 'email',
    Value: email
  });
  var submitInfoManualPayload = {
    UserId: parseInt(alphaPointUserID, 10),
    UserName: userName,
    underReviewLevel: underReviewLevel,
    Config: Config
  };
  submitInfoManual(submitInfoManualPayload);
  reset();
  onSubmit && onSubmit();
};